import { useEffect, useState } from 'react';

export const useFocusInputFunctionality = () => {
  const [focusElementName, setFocusElementName] = useState<string | null>(null);

  useEffect(() => {
    if (focusElementName) {
      const nodeList = document.getElementsByName(focusElementName);

      const inputElements = Array.from(nodeList).filter(
        (element) =>
          element.tagName.toLowerCase() === 'input' || element.tagName.toLowerCase() === 'textarea'
      );

      let element = inputElements?.[0];

      // For ReactQuill there will be no direct match, so we need to search for ql-editor
      if (!element) {
        for (const node of nodeList) {
          const qlEditor = node.querySelector('.ql-editor') as HTMLElement;

          if (qlEditor) {
            element = qlEditor;

            break;
          }
        }
      }

      // A field whose input is named differently from the form field (a chip list's picker):
      // the field marks its container with data-focus-name and its first input is focused.
      if (!element) {
        const escapedName = focusElementName.replace(/["\\]/g, '\\$&');

        element = document
          .querySelector(`[data-focus-name="${escapedName}"]`)
          ?.querySelector('input, textarea') as HTMLElement | undefined;
      }

      if (element) {
        element.focus();
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      setFocusElementName(null);
    }
  }, [focusElementName]);

  return { focusElementName, setFocusElementName };
};
